import React, { PureComponent, PropTypes } from 'react';

import styles from './styles.scss';

export class Checkbox extends PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);

    this.state = { value: props.value || false };
  }

  onClick() {
    this.props.onClick(!this.state.value);
    this.setState({ value: !this.state.value });
  }

  getLabel() {
    if (this.props.label) {
      return this.props.label;
    }
    if (this.props.name) {
      return (<label>{this.props.name}</label>);
    }
    return '';
  }

  render() {
    return (
      <div
        className={[styles.checkbox, this.props.className].join(' ').trim()}
        value={this.state.value}
        onClick={() => this.onClick()}
        aria-hidden
      >
        <div className={[styles.check, this.props.checkClass, this.state.value].join(' ').trim()}>
          {
            this.state.value ?
              <i className='fa fa-check' aria-hidden='true' /> : null
          }
        </div>
        {
          this.getLabel()
        }
      </div>
    );
  }
}

Checkbox.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  checkClass: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.bool,
  label: PropTypes.node,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/shared/checkbox/main.jsx